import React, {useState, useRef, useCallback, useEffect} from "react";
import {
  Drawer,
  Input,
  Tooltip,
  Spin,
  Select
} from "@arco-design/web-react";
import EmptyImg from '@/assets/cut-mix-detail/empty-data-min.png';
import { debounce } from "lodash";
import AddSeo from "@/assets/cut-mix-detail/add-seo.png";
import CopySeo from "@/assets/cut-mix-detail/copy-seo.png";
import "./index.less";
import seoTitle from "@/assets/cut-mix-detail/keyword-min.png";
import { getSeoWords, getSeoWordsInfo } from "@/services/mixCutDetail/mixCutDetail";
import ConfigStore from "@/stores/mixedConfig";
import { IconSearch } from '@arco-design/web-react/icon';
import { observer } from "mobx-react";

type Props = {
  isOpen?: boolean;
  handleCancel: () => void;
  keywords?: string;
  emitChange?: (data: any, type: number) => void;
  style?: any;
  keywordsId?: string | number;
};
const KeyWordsDrawer = (props: Props) => {
  const {
    isOpen = true,
    handleCancel,
    keywords,
    emitChange,
    keywordsId,
    style
  } = props;
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [fetching, setFetching] = useState(false);
  const refFetchId = useRef(null);
  // 添加
  const handleChange = (data, type) => {
    emitChange(data, type);
  }

  useEffect(() => {
    if (keywordsId) {
      getInfoHandle(keywordsId);
    } else {
      setDataList([]);
    }
  }, [keywordsId]);

  const getInfoHandle = (keywordsId) => {
    setLoading(true);
    getSeoWordsInfo(keywordsId).then((res) => {
      if (res.data?.texts) {
        setDataList(JSON.parse(res.data.texts));
      } else {
        setDataList([]);
      }
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    })
  }
  // 远程搜索关键词
  const debouncedFetchUser = useCallback(
    debounce((inputValue) => {
      refFetchId.current = Date.now();
      const fetchId = refFetchId.current;
      setFetching(true);
      setOptions([]);
      getSeoWords({
        query: inputValue
      }).then((res) => {
        if (res.data?.items.length > 0) {
          if (refFetchId.current === fetchId) {
            const options = res.data.items.map((item) => ({
              label: (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  { item.word }
                </div>
              ),
              value: item.id,
            }));
            setFetching(false);
            setOptions(options);
          }
        } else {
          setFetching(false);
        }
      })
    }, 500),
    []
  );

  const getHighlight = (keywords, str ) => {
    if (!keywords) {
      return str;
    }
    let htmlStr = `<span>${str}</span>`;
    htmlStr = htmlStr.replaceAll(
      keywords,
      `<b style='color:#4E45F7;'>${keywords}</b>`
    );
    return htmlStr;
  };
  return (
    <div>
      <Drawer
        className="seo-drawer"
        maskStyle={{
          background: 'transparent'
        }}
        style={style}
        width={555}
        title={
          <div className="seo-header">
            <img src={seoTitle} alt="" />
          </div>
        }
        visible={isOpen}
        footer={null}
        onCancel={() => {
          handleCancel();
        }}>
        <div className="seo-content">
          <Select
            style={{
              marginBottom: 23
            }}
            prefix={
              <IconSearch />
            }
            suffixIcon={
              <span />
            }
            onChange={(value) => {
              if (value) {
                getInfoHandle(value)
                const name = options.find(item => Number(item.value) === Number(value))?.label.props.children;
                ConfigStore.global_settings.keywords = name
                ConfigStore.global_settings.keywords_id = value
              } else {
               setDataList([])
              }
            }}
            showSearch
            options={options}
            placeholder="输入关键字"
            filterOption={false}
            allowClear
            notFoundContent={
              fetching ? (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Spin style={{ margin: 12 }} />
                </div>
              ) : <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  padding: '12px'
                }}
              >
                <img style={{ width: 80, height: 58, marginBottom: 5 }} src={EmptyImg} alt=""/>
                <div style={{ fontSize: 12 }}>暂无数据</div>
              </div>
            }
            onSearch={debouncedFetchUser}
          />

          <div className={"activeName"}>
            当前工程长尾关键词：<span className={"keyword"}>{keywords}</span>
          </div>
          <div className="seo-list">
            {
              !loading && dataList.length === 0 && <div className="empty-data">
                    <img style={{ width: 80, height: 58, marginBottom: 10 }} src={EmptyImg} alt=""/>
                    <div className="empty-text">暂无数据</div>
                </div>
            }
            {
              loading && <Spin />
            }
            {
              !loading && dataList?.length > 0 && dataList.map((item, index) => {
                return (
                  <div key={index} className="seo-list-item">
                    <div className="seo-list-item-card">
                      <div className="circle-box">
                        <div className="circle"/>
                      </div>
                      <div className="info">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: getHighlight(
                              ConfigStore.global_settings.keywords,
                              item
                            ),
                          }}
                        ></span>
                      </div>
                    </div>
                    <div className="seo-btns">
                      <Tooltip content='添加到台词组'>
                        <img onClick={() => {
                          handleChange(item, 'add');
                        }} src={AddSeo} alt=""/>
                      </Tooltip>
                      <Tooltip content='添加至新台词组'>
                        <img onClick={() => {
                          handleChange(item, 'copy');
                        }}  style={{marginLeft: 17}} src={CopySeo} alt=""/>
                      </Tooltip>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default observer(KeyWordsDrawer);
